export default function getValueOffPercent(value: number, price: number): number {
  return value > 0 ? Math.round((value - price) * 100 / value) : 0
}
